import { walletNotInstalledMessage } from '../components/WalletNotInstalledMessage.js'
import { pinJSONToIPFS } from './pinata.js'
require('dotenv').config()
const alchemyKey = process.env.REACT_APP_ALCHEMY_KEY
const contractABI = require('../contract-abi.json')
const contractAddress = '0x4C4a07F737Bf57F6632B6CAB089B78f62385aCaE'
const { createAlchemyWeb3 } = require('@alch/alchemy-web3')
const web3 = createAlchemyWeb3(alchemyKey)

export const connectWallet = async () => {
  if (window.ethereum) {
    try {
      const addressArray = await window.ethereum.request({
        method: 'eth_requestAccounts'
      })
      const obj = {
        status: '',
        address: addressArray[0]
      }
      return obj
    } catch (err) {
      return {
        address: '',
        status: '😥 ' + err.message
      }
    }
  } else {
    return {
      address: '',
      status: walletNotInstalledMessage
    }
  }
}

export const getCurrentWalletConnected = async () => {
  if (window.ethereum) {
    try {
      const addressArray = await window.ethereum.request({
        method: 'eth_accounts'
      })
      if (addressArray.length > 0) {
        return {
          address: addressArray[0],
          status: ''
        }
      } else {
        return {
          address: '',
          status: '🦊 Connect to Metamask using the top right button.'
        }
      }
    } catch (err) {
      return {
        address: '',
        status: '😥 ' + err.message
      }
    }
  } else {
    return {
      address: '',
      status: walletNotInstalledMessage
    }
  }
}

// async function loadContract() {
//   return new web3.eth.Contract(contractABI, contractAddress);
// }

export const mintNFT = async (url) => {
  // if (url.trim() == "" || name.trim() == "" || description.trim() == "") {
  //   return {
  //     success: false,
  //     status: "❗Please make sure all fields are completed before minting.",
  //   };
  // }

  // make metadata
  const metadata = {
    image: url
    // metadata.name = name;
    // metadata.description = description;
  }

  const pinataResponse = await pinJSONToIPFS(metadata)
  if (!pinataResponse.success) {
    return {
      success: false,
      status: '😢 Something went wrong while uploading your tokenURI.'
    }
  }
  const tokenURI = pinataResponse.pinataUrl

  window.contract = await new web3.eth.Contract(contractABI, contractAddress)

  const transactionParameters = {
    to: contractAddress, // Required except during contract publications.
    from: window.ethereum.selectedAddress, // must match user's active address.
    data: window.contract.methods
      .mintNFT(window.ethereum.selectedAddress, tokenURI)
      .encodeABI()
  }

  try {
    const txHash = await window.ethereum.request({
      method: 'eth_sendTransaction',
      params: [transactionParameters]
    })
    return {
      success: true,
      status:
        '✅ Check out your transaction on Etherscan: https://ropsten.etherscan.io/tx/' +
        txHash
    }
  } catch (error) {
    return {
      success: false,
      status: '😥 Something went wrong: ' + error.message
    }
  }
}
